import script from "./InternalUsers.vue?vue&type=script&setup=true&lang=js"
export * from "./InternalUsers.vue?vue&type=script&setup=true&lang=js"

import "./InternalUsers.vue?vue&type=style&index=0&id=3b919436&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b919436"]])

export default __exports__